import { IconProps } from "./Icon.model";

export function Rotate3d({ size = 16, fill = "currentColor" }: IconProps) {
  const fillColor =
    fill === "currentColor" ? "currentColor" : `var(--${fill}-a8)`;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.47712 1.6645C6.7669 1.2593 6.91178 1.0567 6.83081 0.93962C6.74985 0.82254 6.53125 0.883302 6.09406 1.00482C3.50687 1.72397 1.50382 3.86115 0.961077 6.53395C0.939523 6.64009 0.928746 6.69316 0.946287 6.74495C0.963828 6.79673 1.00607 6.83343 1.09056 6.90681L1.7642 7.49196L1.77351 7.50068C2.45831 8.14274 3.26679 8.63863 4.15226 8.99404C4.40238 9.09443 4.52743 9.14462 4.61655 9.08C4.70567 9.01539 4.69754 8.87204 4.68128 8.58535C4.66767 8.3454 4.66114 8.10563 4.66152 7.8668C4.66504 5.60984 5.28484 3.33168 6.47712 1.6645Z"
        fill={fillColor}
      />
      <path
        d="M0.870441 8.49684C0.85527 8.48367 0.831894 8.4956 0.833314 8.51572C1.06051 11.7357 3.37553 14.3745 6.42279 15.0668C6.86412 15.1671 7.08478 15.2172 7.15987 15.095C7.23497 14.9729 7.07924 14.7808 6.76778 14.3966C5.94707 13.3842 5.38335 12.1828 5.04712 10.914C5.01639 10.7981 5.00103 10.7401 4.96341 10.702C4.92579 10.6639 4.86832 10.648 4.75338 10.6163C3.31538 10.2195 1.97257 9.52695 0.870441 8.49684Z"
        fill={fillColor}
      />
      <path
        d="M9.26068 14.9719C9.33447 15.0394 9.37136 15.0732 9.41873 15.0857C9.46609 15.0983 9.513 15.0876 9.60681 15.0663C12.5567 14.3951 14.82 11.8996 15.1663 8.81902C15.1703 8.78361 15.1308 8.76028 15.102 8.78101C13.122 10.2326 10.5016 11.0218 7.92749 11.0292C7.63981 11.03 7.3518 11.0211 7.0645 11.002C6.77947 10.9832 6.63696 10.9737 6.57201 11.0631C6.50707 11.1525 6.55632 11.2789 6.65481 11.5316C7.06164 12.5752 7.66087 13.509 8.45975 14.2392L9.26068 14.9719Z"
        fill={fillColor}
      />
      <path
        d="M14.9622 7.22347C15.0576 7.15475 15.1053 7.12039 15.1273 7.06755C15.1492 7.01472 15.1403 6.95847 15.1226 6.84596C14.6405 3.79524 12.269 1.37877 9.25401 0.851418C9.1578 0.83459 9.1097 0.826176 9.06247 0.841632C9.01524 0.857087 8.98002 0.893646 8.90957 0.966763L8.17937 1.7246L8.17455 1.7294C6.81451 3.08494 6.00463 5.41969 6.00081 7.86892C6.00008 8.33237 6.02822 8.79453 6.08568 9.24959C6.10311 9.38764 6.11182 9.45666 6.15972 9.50526C6.20763 9.55386 6.27614 9.56318 6.41318 9.58182C6.90859 9.64921 7.41411 9.68181 7.92367 9.68034C10.2502 9.67365 12.5892 8.95565 14.3159 7.68897L14.3206 7.68548L14.9622 7.22347Z"
        fill={fillColor}
      />
    </svg>
  );
}

